import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGameView } from "@grassrootly/api";

export interface GameViewState {
  games: IGameView[];
}

const initialState: GameViewState = {
  games: [],
};

export const gameViewSlice = createSlice({
  name: "gameView",
  initialState,
  reducers: {
    setGameView: (state, action: PayloadAction<IGameView>) => {
      const existingIndex = state.games.findIndex((g) => g.game_id === action.payload.game_id);
      if (existingIndex !== -1) {
        state.games[existingIndex] = action.payload;
      } else {
        state.games.push(action.payload);
      }
    },
    clearGameViews: (state) => {
      state.games = [];
    },
    removeGameView: (state, action: PayloadAction<number>) => {
      state.games = state.games.filter((g) => g.game_id !== action.payload);
    },
  },
});

export const gameViewActions = gameViewSlice.actions;
export default gameViewSlice.reducer;
